import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CandidateService } from '../../core/services/candidate.service';
import { UserService } from '../../core/services/user.service';
import { EmployeeService } from '../../core/services/employee.service';
import { dateTimeFormatters, base64toBlob } from '../factory/common.service';
import { MessageService } from '../../shared/factory/message.service';
import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { BoardingModel, BoardingFormBuilder } from '../models/boarding-model';
import { CommonService } from '../../shared/factory/common.service';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { MatSelectModule } from '@angular/material/select';
// import { JasperReportParameter } from 'src/app/core/services/manage-report.service';

// Candidate Offer Dialog
@Component({
    selector: 'app-candidate-offer-dialog',
    template: `<h2 mat-dialog-title class="d-inline-flex align-items-center mb-0"><mat-icon matSuffix>local_offer</mat-icon><span>&nbsp;&nbsp;{{data.id ? 'Job Offer' : 'Select Offer Letter'}}</span></h2>
    <hr/>
     <mat-dialog-content>
      <p>
        <label>Offer File</label>
        <a mat-raised-button color="warn" class="w-100 text-left" (click)="fileInput.click()">
          <mat-icon matSuffix>file_copy</mat-icon>&nbsp;&nbsp;
          <span>{{offerFile.value ? selectedFileName : "Select (.pdf,.doc,.docx)"}}</span>
          <input #fileInput [formControl]="offerFile" type="file" (change)="onFileInput($event)" style="display:none;" accept=".pdf,.doc,.docx" [required]="data.id ? 'false' : 'true'" />
        </a>
        <mat-error *ngIf="offerFile.invalid">Offer Letter is required!</mat-error>
      </p>
      <p *ngIf="data.id">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Job Offer Status</mat-label>
          <mat-select [formControl]="offerStatus" [required]="data.id ? 'false' : 'true'">
            <mat-option value="OFFERED">Offered</mat-option>
            <mat-option value="REJECTED">Rejected</mat-option>
            <mat-option value="ACCEPTED">Accepted</mat-option>
            <mat-option value="NO_SHOWUP">No Showup</mat-option>
          </mat-select>
          <mat-hint>Select offer status</mat-hint>
          <mat-error *ngIf="offerStatus.invalid">Required!</mat-error>
        </mat-form-field>
      </p>
     </mat-dialog-content>
    <hr/>
    <div class="text-right">
      <button [disabled]="offerFile.invalid || offerStatus.invalid" (click)="applyAction()" mat-raised-button color="primary" class="w-100">Send</button>
      <button mat-raised-button mat-dialog-close class="w-100 mt-2">Cancel</button>
    </div>`
})
export class CandidateOfferDialogComponent implements OnInit {

    offerFile = new FormControl('', [this.data.id ? Validators.nullValidator : Validators.required]);
    offerStatus = (this.data.id ? new FormControl(this.data.jobOfferStatus, [Validators.required]) : new FormControl(''));
    selectedFileName = "";
    offerLetter: any = null;

    constructor(
        public dialogRef: MatDialogRef<CandidateOfferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _candidateService: CandidateService,
        private messageService: MessageService
    ) { }

    ngOnInit() { }

    onFileInput($event) {
        var regex = /(.*?)\.(docx|doc|pdf)$/;
        if (($event.srcElement.files.length > 0) && (regex.test($event.srcElement.files[0].name))) {
            this.selectedFileName = $event.srcElement.files[0].name;
            this.offerLetter = $event.srcElement.files[0];
        }
    }

    applyAction() {
        this.data.jobOfferStatus = null;
        let formData: FormData = new FormData();
        if (this.offerLetter !== null) formData.append('offerLetter', this.offerLetter, this.offerLetter.name);
        if (this.data.id) {
            this.data.jobOfferStatus = this.offerStatus.value;
            let jobOfferDTOBlob = new Blob([JSON.stringify(this.data)], {
                type: 'application/json'
            });
            formData.append('jobOfferDTO', jobOfferDTOBlob);
            this._candidateService.updateOfferLetter(formData).subscribe(res => {
                this.messageService.display('Updating offer letter is successfull!', 'OK', 'success');
                this.dialogRef.close('applied');
            });
        } else {
            let jobOfferDTOBlob = new Blob([JSON.stringify(this.data)], {
                type: 'application/json'
            });
            formData.append('jobOfferDTO', jobOfferDTOBlob);
            this._candidateService.sendOfferLetter(formData).subscribe(res => {
                this.messageService.display('Sending offer letter is successfull!', 'OK', 'success');
                this.dialogRef.close('applied');
            });
        }
    }

}

// Interview Action Dialog
@Component({
    selector: 'app-interview-action-dialog',
    template: `<h2 mat-dialog-title class="d-inline-flex align-items-center mb-0"><mat-icon matSuffix>feedback</mat-icon><span>&nbsp;&nbsp;Select Action</span></h2>
    <hr/>
    <mat-dialog-content>
      <p class="mb-0">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Permissions</mat-label>
          <mat-select [formControl]="action" required>
            <mat-option value="">None</mat-option>
            <mat-option value="NEXT_ROUND">Next Round</mat-option>
            <mat-option value="ONHOLD">On Hold</mat-option>
            <mat-option value="SELECTED">Selected</mat-option>
            <mat-option value="REJECTED">Rejected</mat-option>
          </mat-select>
          <mat-hint>Select Permissions</mat-hint>
          <mat-error *ngIf="action.invalid">Required!</mat-error>
        </mat-form-field>
      </p>
    </mat-dialog-content>
    <hr/>
    <div class="text-right">
      <button [disabled]="action.invalid" (click)="applyAction()" mat-raised-button color="primary" class="w-100">Apply</button>
      <button mat-raised-button mat-dialog-close class="w-100 mt-2">Cancel</button>
    </div>`
})
export class InterviewActionDialogComponent implements OnInit {

    action = new FormControl('', [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<InterviewActionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _candidateService: CandidateService,
        private messageService: MessageService
    ) { }

    ngOnInit() { }

    applyAction() {
        let formData = { "id": this.data.interviewId, "interviewRoundId": this.data.roundId, "interviewRoundStatus": this.action.value };
        this._candidateService.updateInterviewAction(formData).subscribe(res => {
            this.messageService.display('Update is successfull!', 'OK', 'success');
            this.dialogRef.close('applied');
        });
    }

}

// Employee Startup Dialog
@Component({
    selector: 'app-employee-startup-dialog',
    template: `<h2 mat-dialog-title class="d-inline-flex align-items-center mb-0"><mat-icon matSuffix>person</mat-icon><span>&nbsp;&nbsp;Create Employee</span></h2>
    <hr/>
    <mat-dialog-content>
        <p>
            <label>Aggreement File</label>
            <a mat-raised-button color="warn" class="w-100 text-left" (click)="fileInput.click()">
                <mat-icon matSuffix>file_copy</mat-icon>&nbsp;&nbsp;
                <span>{{inputFile.value ? selectedFileName : "Select (.pdf,.doc,.docx)"}}</span>
                <input #fileInput [formControl]="inputFile" type="file" (change)="onFileInput($event)" style="display:none;" accept=".pdf,.doc,.docx" required />
            </a>
            <mat-error *ngIf="inputFile.invalid">Agreement is required!</mat-error>
        </p>
        <p>
            <mat-form-field class="w-100" appearance="outline">
                <mat-label>Manager Employee</mat-label>
                <mat-select [formControl]="managerEmpId" required>
                    <mat-option *ngFor="let employee of data.employeeLite; let m = index;" [value]="employee.employeeLite.id">{{employee.employeeLite.firstName + ' ' + employee.employeeLite.lastName}}</mat-option>
                </mat-select>
                <mat-hint>Select manager employee</mat-hint>
                <mat-error *ngIf="managerEmpId.invalid">Employee required!</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field class="w-100" appearance="outline">
                <mat-label>Joining Date</mat-label>
                <input matInput readonly [formControl]="dateOfJoining" [matDatepicker]="datepicker1" placeholder="Select joining date" disabled>
                <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
                <mat-datepicker touchUi="true" #datepicker1 disabled="false"></mat-datepicker>
                <mat-hint>Select joining date</mat-hint>
            </mat-form-field>
        </p>
    </mat-dialog-content>
    <hr/>
    <div class="text-right">
      <button [disabled]="inputFile.invalid || managerEmpId.invalid || dateOfJoining.invalid" (click)="applyAction()" mat-raised-button color="primary" class="w-100">Send</button>
      <button mat-raised-button mat-dialog-close class="w-100 mt-2">Cancel</button>
    </div>`
})
export class EmployeeStartupDialogComponent implements OnInit {

    inputFile = new FormControl('', [Validators.required]);
    managerEmpId = new FormControl('', [Validators.required]);
    dateOfJoining = new FormControl('', [Validators.required]);
    selectedFileName = "";
    agreementLetter: any = null;

    constructor(
        public dialogRef: MatDialogRef<CandidateOfferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _candidateService: CandidateService,
        private messageService: MessageService
    ) { }

    ngOnInit() { }

    onFileInput($event) {
        var regex = /(.*?)\.(docx|doc|pdf)$/;
        if (($event.srcElement.files.length > 0) && (regex.test($event.srcElement.files[0].name))) {
            this.selectedFileName = $event.srcElement.files[0].name;
            this.agreementLetter = $event.srcElement.files[0];
        }
    }

    applyAction() {
        let formData: FormData = new FormData();
        if (this.agreementLetter !== null) formData.append('agreementFile', this.agreementLetter, this.agreementLetter.name);
        let employeeDTO = new Blob([JSON.stringify({ "managerEmpId": this.managerEmpId.value, "dateOfJoining": dateTimeFormatters.formatDate(this.dateOfJoining.value) })], {
            type: 'application/json'
        });
        formData.append('employeeDTO', employeeDTO);
        this._candidateService.sendConfirmation(formData, this.data.jobOfferId).subscribe(res => {
            this.messageService.display('Confirmation sending is successfull!', 'OK', 'success');
            this.dialogRef.close('applied');
        });
    }

}

// Profile Picture Dialog (Employee, etc)
@Component({
    selector: 'app-profile-picture-dialog',
    template: `<h2 mat-dialog-title class="d-inline-flex align-items-center mb-0"><mat-icon matSuffix>{{data.profileSelected ? 'edit' : 'add_a_photo'}}</mat-icon><span>&nbsp;&nbsp;Profile Picture</span></h2>
    <hr/>
    <mat-dialog-content>
        <div class="row">
            <div class="col-md-12">
                <p>
                    <label>Profile Picture</label>
                    <a mat-raised-button color="warn" class="w-100 text-left" (click)="fileInput.click()">
                        <mat-icon matSuffix>file_copy</mat-icon>&nbsp;&nbsp;
                        <span>{{profilePicture.value ? selectedFileName : "Select (.png,.jpg,.jpeg)"}}</span>
                        <input #fileInput [formControl]="profilePicture" type="file" (change)="fileChangeEvent($event)" style="display:none;" accept=".png,.jpg,.jpeg" required />
                    </a>
                    <mat-error *ngIf="profilePicture.invalid">Profile picture is required!</mat-error>
                </p>
            </div>
            <div class="col-md-6">
                <p>
                    <image-cropper
                        [imageChangedEvent]="imageChangedEvent"
                        [maintainAspectRatio]="true"
                        [aspectRatio]="4 / 5"
                        [resizeToWidth]="256"
                        format="png"
                        (imageCropped)="imageCropped($event)"
                        (imageLoaded)="imageLoaded()"
                        (loadImageFailed)="loadImageFailed()"></image-cropper>
                </p>
            </div>
            <div class="col-md-6">
                <p>
                    <img [src]="croppedImage" />
                </p>
            </div>
        </div>
    </mat-dialog-content>
    <hr/>
    <div class="text-right">
      <button [disabled]="profilePicture.invalid" (click)="applyAction()" mat-raised-button color="primary" class="w-100">{{data.profileSelected ? 'Update' : 'Upload'}} Profile Picture</button>
      <button mat-raised-button mat-dialog-close class="w-100 mt-2">Cancel</button>
    </div>`
})
export class ProfilePictureDialogComponent implements OnInit {

    profilePicture = new FormControl(null, [Validators.required]);
    imageChangedEvent: any = '';
    croppedImage: any = '';
    selectedFileName;

    constructor(
        public dialogRef: MatDialogRef<ProfilePictureDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private messageService: MessageService,
        private employeeService: EmployeeService
    ) { }

    ngOnInit() { }

    fileChangeEvent(event: any): void {
        if (this.profilePicture.value) {
            this.selectedFileName = event.srcElement.files[0].name;
            this.imageChangedEvent = event;
        } else {
            this.selectedFileName = null;
            this.imageChangedEvent = '';
            this.croppedImage = '';
        }
    }

    imageCropped(image: string) {
        this.croppedImage = image;
    }

    imageLoaded() {
        // show cropper
    }

    loadImageFailed() {
        this.messageService.display('Image selection failed!', 'OK', 'error');
    }

    applyAction() {
        // Split the base64 string in data and contentType
        var block = this.croppedImage.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1];
        // get the real base64 content of the file
        var realData = block[1].split(",")[1];
        // Convert it to a blob to upload
        var blob = base64toBlob(realData, contentType);
        let formData: FormData = new FormData();
        if (this.profilePicture !== null) formData.append('profilePic', blob, this.selectedFileName);
        this.employeeService.uploadEmployeeProfilePic(this.data.employeeId, formData).subscribe((res) => {
            this.messageService.display('Profile picture is uploaded successfully!', 'OK', 'success');
            this.dialogRef.close({ data: 'uploaded', img: this.croppedImage });
        });
    }

}

// Dashboard Help Dialog
@Component({
    selector: 'app-dashboard-help-dialog',
    template: `<h2 mat-dialog-title class="d-inline-flex align-items-center mb-0"><mat-icon matSuffix>feedback</mat-icon><b>&nbsp;&nbsp;Help</b></h2>
    <hr/>
    <mat-dialog-content>
        <mat-accordion>
            <mat-expansion-panel class="mt-2" [expanded]="contentId == 0" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>1. Employee Count</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- The total number of members employed at the company over time.</p>
                <p>- Includes currently working and not-working both.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 1" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>2. Interview Statistics</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- The total number of pending, in-progress and on-hold candidates.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 2" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>3. Candidate Count</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- The total number of candidates available right now.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 3" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>4. Candidate Schedule</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- Displays interview schedules per date with details.</p>
                <p>- Includes completed interviews.</p>
                <p>- Previous months interview schedules can also be viewed.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 4" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>5. Rejection Ratio</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- Rejection Ratio is a measure of rejected candidates to interviewed candidates.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 5" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>6. Requisition</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- Department supervisors who want to hire additional staff, or replace employees who resign or are terminated, generally have to complete a job requisition.</p>
                <p>- A requisition is forwarded to the human resources department for handling by the recruiter.</p>
                <p>- The recruiter then places job postings based on the requisition and discussions with the hiring manager or department supervisor.</p>
                <p>- The total number of approved, rejected and open job requisitions.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 6" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>7. Candidates Added</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- Total number of candidates added per month for given months.</p>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="contentId == 7" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>8. Interview Activities</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- Total number of candidate interviews taken per month for given months.</p>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2" [expanded]="contentId == 8" (opened)="scrollToview()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <b>9. Shortlisted Candidates</b>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>- Total number of shortlisted candidates for given positions.</p>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-dialog-content>
    <hr/>
    <div class="text-right">
      <button mat-raised-button mat-dialog-close class="w-100 mt-2">Cancel</button>
    </div>`,
    styles: ['p { margin: 0; }']
})
export class DashboardHelpDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<InterviewActionDialogComponent>,
        public myElement: ElementRef,
        @Inject(MAT_DIALOG_DATA) public contentId: any
    ) { }

    ngOnInit() { }

    scrollToview() {
        setTimeout(() => {
            const el = this.myElement.nativeElement.querySelector('.mat-expanded');
            el.scrollIntoView();
        }, 100);
    }
}


// Confirmation Box

@Component({
    selector: 'app-confirm-box',
    template: `<div  mat-dialog-title><span>{{title}}</span>
    </div>
    <div mat-dialog-content style="margin-top:20px">
      <p style="font-size:16px;">{{message+"?"}} </p>
    </div>
    <div mat-dialog-actions class="float-right">
      <button mat-button (click)="onNoClick()">No</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial (click)="onYesClick()">Yes</button>
    </div>`
})
export class ConfirmationBoxComponent implements OnInit {

    title: string;
    message: string;
    constructor(
        public dialogRef: MatDialogRef<ConfirmationBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
        this.title = this.data.title;
        this.message = this.data.message;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onYesClick() {
        this.dialogRef.close("applied");
    }
}
@Component({
    selector: 'Boarding-component',
    template: `<div [formGroup]="boardingForm"><h1 mat-dialog-title align="center"> Boarding process </h1>
    <div mat-dialog-content>
        <div class="col-sm">
        <mat-form-field>
            <input matInput placeholder="Company Name" formControlName="companyName">
        </mat-form-field>
        </div>
        <div class="col-sm">
        <mat-form-field>
            <input matInput placeholder="Department Name" formControlName="departmentName">
        </mat-form-field>
        </div>
        <div class="col-sm">
        <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Timezone</mat-label>
                                <mat-select formControlName="timeZone">
                                    <mat-option *ngFor="let timezone of timeZones; let i = index;" [value]="timezone.value + ' - ' + timezone.text">{{timezone.value + ' - ' + timezone.text}}</mat-option>
                                </mat-select>
                                <mat-hint>Select timezone</mat-hint>
         </mat-form-field>
        </div>
       
         </div>
         <div class="col-sm">
             <div mat-dialog-actions align="center">
             <button class="mat-raised-button mat-primary" align="end"(click)="save()">Save</button>
             </div>
         </div>
    </div>`
})

export class BoardingComponent implements OnInit {

    boarding: BoardingFormBuilder = new BoardingFormBuilder();
    boardingModel: BoardingModel = this.boarding.boardingModel;
    boardingForm: FormGroup = this.boarding.boardingForm;
    timeZones;
    countries;

    module = {
        name: ''
    };

    constructor(
        private userService: UserService,
        public router: Router,
        public commonServices: CommonService,
        public messageService: MessageService,
        public dialogRef: MatDialogRef<BoardingComponent>
    ) { }

    ngOnInit() {
        const temp = sessionStorage.getItem('loginData');
        this.boardingModel.moduleName = JSON.parse(temp).moduleName;
        this.commonServices.fetchTimeZones().subscribe(res => {
            this.timeZones = res;
        });
        this.commonServices.fetchCountries().subscribe(res => {
            this.countries = res.countries;
        });
    }
    save() {
        this.userService.checkBoardingStatus(this.boardingModel).subscribe((res) => {
            this.dialogRef.close();
            this.messageService.display('Boarding process is successfully completed ! Module name : ' + this.boardingModel.moduleName, 'OK', 'success');
        });
    }
}

@Component({
    selector: 'app-confirmation-dialog',
    template: `<div mat-dialog-content>
    {{message}}
   </div>
   <div mat-dialog-actions>
     <button mat-button (click)="onNoClick()">Cancel</button>
     <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
   </div>`
})
export class ConfirmationDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public message: string) { }

    onNoClick(): void {
        this.dialogRef.close();
    }
    ngOnInit() {
    }

}

@Component({
    selector: 'Add-Parameter-component',
    template: `
    <div><h1 mat-dialog-title class="font-weight-bold"> {{data.isEdit ? 'Edit' : 'Add'}} Field </h1>
    <hr>      
        <div mat-dialog-content style="margin-top:20px" [formGroup]="parametReport">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Parameter Name </mat-label>
                        <input matInput  placeholder="Enter Parameter Name" formControlName="name" autofocus>
                        <mat-error *ngIf="parametReport.get('name').invalid">Parameter Name is required!</mat-error>
                    </mat-form-field>
                </div>                    
                <div class="col-md-12">
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>parameters Id </mat-label>
                            <input matInput  placeholder="This Id should be as per the jaspareport fields Id"  formControlName="jasperReportId">
                            <mat-error *ngIf="parametReport.get('jasperReportId').invalid">Id is required!</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Parameter Type:</mat-label> 
                        <mat-select formControlName="type">
                            <mat-option *ngFor="let type of parameterTypes" [value]="type">
                            {{type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-md-12">
            <div mat-dialog-actions class="float-right" >
                <button class="mat-raised-button mat-primary" align="end" (click)="save()" [disabled]="parametReport.invalid">
                    Save</button>
                <button mat-raised-button mat-dialog-close class="ml-3" (click)="cancel">Cancel</button>
            </div>
        </div>
    </div>`
})

export class AddParameterComponent implements OnInit {

    @ViewChild("selectValueInput") selectValueInput: ElementRef;
    parameterTypes = ['Date', 'String', 'DateTimeAdapter', 'Number','Long','Integer','Double','Employee','LeaveType'];
    parametReport: FormGroup;
    isVisible = false;
    selectValue = [];
    removable: boolean = true;
    selectable: boolean = true;
    // separatorKeysCodes = const [ENTER, COMMA];
    isType = false;
    constructor(
        public dialogRef: MatDialogRef<AddParameterComponent>,
        public myElement: ElementRef,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder
    ) {
        this.parametReport = this.fb.group({
            name: [''],
            jasperReportId: [''],
            type: ['']
        })
    }

    ngOnInit() {
        console.log(this.data.isEdit)
        if (this.data.isEdit) {
            this.parametReport.patchValue({
                name: this.data.dataSource?.name,
                jasperReportId: this.data?.dataSource?.jasperReportId,
                type: this.data?.dataSource?.type,
            })
        }
    }

    save() {
        this.dialogRef.close({ fieldsForm: this.parametReport.value });
    }


}
